import { apiFetch } from "./client.ts";

// Tickets
export async function listTickets(token: string | null, params?: { clientId?: string; status?: string; priority?: string; search?: string; limit?: number }) {
  const q = new URLSearchParams();
  if (params?.clientId) q.set("clientId", params.clientId);
  if (params?.status) q.set("status", params.status);
  if (params?.priority) q.set("priority", params.priority);
  if (params?.search) q.set("search", params.search);
  if (params?.limit) q.set("limit", String(params.limit));
  return apiFetch(`/api/v1/support/tickets?${q}`, { token });
}

export async function getTicketSummary(token: string | null) {
  return apiFetch("/api/v1/support/tickets/summary", { token });
}

export async function createTicket(token: string | null, data: {
  clientId: string; title: string; description: string;
  category?: string; priority?: string; assignedTo?: string;
  projectId?: string; dueAt?: string;
}) {
  return apiFetch("/api/v1/support/tickets", { token, method: "POST", body: JSON.stringify(data) });
}

export async function assignTicket(token: string | null, id: string, version: number, assignedTo: string) {
  return apiFetch(`/api/v1/support/tickets/${id}/assign`, { token, method: "POST", body: JSON.stringify({ version, assignedTo }) });
}

export async function updateTicketStatus(token: string | null, id: string, version: number, status: string) {
  return apiFetch(`/api/v1/support/tickets/${id}/status`, { token, method: "POST", body: JSON.stringify({ version, status }) });
}

export async function addTicketReply(token: string | null, id: string, data: {
  body: string; replyType: string; authorId: string; authorName: string; isInternal?: boolean;
}) {
  return apiFetch(`/api/v1/support/tickets/${id}/reply`, { token, method: "POST", body: JSON.stringify(data) });
}

// Notifications
export async function listNotifications(token: string | null, params?: { status?: string; type?: string; limit?: number }) {
  const q = new URLSearchParams();
  if (params?.status) q.set("status", params.status);
  if (params?.type) q.set("type", params.type);
  if (params?.limit) q.set("limit", String(params.limit));
  return apiFetch(`/api/v1/support/notifications?${q}`, { token });
}

export async function getUnreadCount(token: string | null) {
  return apiFetch("/api/v1/support/notifications/unread-count", { token });
}

export async function markNotificationRead(token: string | null, id: string) {
  return apiFetch(`/api/v1/support/notifications/${id}/read`, { token, method: "POST", body: JSON.stringify({}) });
}

export async function markAllNotificationsRead(token: string | null) {
  return apiFetch("/api/v1/support/notifications/mark-all-read", { token, method: "POST", body: JSON.stringify({}) });
}

// Meetings
export async function listMeetings(token: string | null, params?: { clientId?: string; projectId?: string; ticketId?: string }) {
  const q = new URLSearchParams();
  if (params?.clientId) q.set("clientId", params.clientId);
  if (params?.projectId) q.set("projectId", params.projectId);
  if (params?.ticketId) q.set("ticketId", params.ticketId);
  return apiFetch(`/api/v1/support/meetings?${q}`, { token });
}

export async function createMeeting(token: string | null, data: {
  title: string; summary: string; meetingDate: string;
  attendees?: string[]; actionItems?: string[];
  clientId?: string; projectId?: string; ticketId?: string;
}) {
  return apiFetch("/api/v1/support/meetings", { token, method: "POST", body: JSON.stringify(data) });
}

// Customer Health
export async function listCustomerHealth(token: string | null, params?: { status?: string }) {
  const q = new URLSearchParams();
  if (params?.status) q.set("status", params.status);
  return apiFetch(`/api/v1/support/health?${q}`, { token });
}

export async function getHealthSummary(token: string | null) {
  return apiFetch("/api/v1/support/health/summary", { token });
}

export async function updateCustomerHealth(token: string | null, data: {
  clientId: string; openTickets?: number; activeProjects?: number; overdueInvoices?: number; notes?: string;
}) {
  return apiFetch("/api/v1/support/health", { token, method: "POST", body: JSON.stringify(data) });
}

// SLA
export async function listSlas(token: string | null) {
  return apiFetch("/api/v1/support/sla", { token });
}

export async function getSlaBreaches(token: string | null) {
  return apiFetch("/api/v1/support/sla/breaches", { token });
}

export async function createSla(token: string | null, data: {
  name: string; priority: string;
  responseTargetMinutes: number; resolutionTargetMinutes: number;
  description?: string; isDefault?: boolean;
}) {
  return apiFetch("/api/v1/support/sla", { token, method: "POST", body: JSON.stringify(data) });
}
